import Button from '@/components/DesignLibrary/Button';

import trackEvents from '@/helpers/trackEvents';

type Props = {
  onClick: () => Promise<void>;
  isSubmitting: boolean;
};

const SubmitButton: React.FC<Props> = ({ onClick, isSubmitting }) => {
  trackEvents.track('render - SaveButton');

  return (
    <Button
      type="submit"
      variant="primary"
      size="md"
      onClick={onClick}
      loading={isSubmitting}
    >
      Submit
    </Button>
  );
};

export default SubmitButton;
